import React from 'react';
import { addSpace, rescueHtml } from "../Components/Tools";
import Logo from '../Img/Logo_projets&finances.png';


const Page2NomDonneesGenerales = (props) =>
{
    const blue = '#069BD3';
    const green = '#59B44A';
    const orange = '#FFA500';
    const red = '#FF0000';
    const greyChapter = '#DBDBDB';
    const greyclair = '#FAFAFA';
    const circle = (props.height*70/950);
    const fontsize = (props.height*12/890);
    const sizelogo = props.width/6;
    const height = (props.height*20/950);

    return (
        <div style={{width: '100%', height: '100%', padding: 20}}>
            
            {/* Header Photos du projet */}
            <div style={{height: '30%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <div style={{flex: 1}}></div>
                {props.logo && (
                    <img style={{objectFit: 'contain', maxHeight: '100%', maxWidth: '100%', borderRadius: 5}} src={props.logo} alt="Logo" />
                )}
                <div style={{flex: 1}}></div>
            </div>

            {/* Container 1 Numero et nom du projet  */}
            <div style={{height: '40%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <div>
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <div
                        style={props.projet[27] === green?
                        {margin: 3, border: '2px solid '+green, borderRadius: 100, width: circle, height: circle, backgroundColor: green}
                        :
                        {margin: 3, border: '2px solid '+green, borderRadius: 100, width: circle, height: circle, backgroundColor: 'white'}}>
                        </div>
                        <div
                        style={props.projet[27] === orange?
                        {margin: 3, border: '2px solid '+orange, borderRadius: 100, width: circle, height: circle, backgroundColor: orange}
                        :
                        {margin: 3, border: '2px solid '+orange, borderRadius: 100, width: circle, height: circle, backgroundColor: 'white'}}>
                        </div>
                        <div
                        style={props.projet[27] === red?
                        {margin: 3, border: '2px solid '+red, borderRadius: 100, width: circle, height: circle, backgroundColor: red}
                        :
                        {margin: 3, border: '2px solid '+red, borderRadius: 100, width: circle, height: circle, backgroundColor: 'white'}}>
                        </div>
                    </div>
                    <div style={{display: 'flex', justifyContent: 'center', marginTop: 5}}>
                        <p style={{fontSize: (fontsize+8)}}>Projet n° {props.projet[2]}</p>
                    </div>
                    <p style={{marginTop: 15, color: blue, fontSize: (fontsize+12)}}>{props.projet[3]}</p>
                </div>
            </div>

            <div style={{height: '10%', justifyContent: 'center', alignItems: 'center', fontSize: fontsize}}>
                {/* Montant du projet */}
                <div style={{display: 'flex', marginBottom: fontsize-4}}>
                    <div style={{padding: 5, backgroundColor: greyChapter, width: 270, borderTopLeftRadius: 3, borderBottomLeftRadius: 3}}>
                        <p>Montant du projet (en € TTC)</p>
                    </div>
                    <div style={{flex: 1, padding: 5, backgroundColor: greyclair, borderTopRightRadius: 3, borderBottomRightRadius: 3}}>
                        <p style={{}}>{props.projet[9] ? addSpace(parseFloat(props.projet[9])) + "€" : "0€"}</p>
                    </div>
                </div>

                {/* Politique publique de rattachement */}
                <div style={{display: 'flex', marginBottom: fontsize-4}}>
                    <div style={{padding: 5, backgroundColor: greyChapter, width: 270, borderTopLeftRadius: 3, borderBottomLeftRadius: 3}}>
                        <p>Politique publique de rattachement</p>
                    </div>
                    <div style={{flex: 1, padding: 5, backgroundColor: greyclair, borderTopRightRadius: 3, borderBottomRightRadius: 3}}>
                        <p style={{overflow: 'hidden'}}>{props.projet[7] ? rescueHtml(props.projet[7]).replace('|', '') : ""}</p>
                    </div>
                </div>

                {/* Maître d'ouvrage */}
                <div style={{display: 'flex', marginBottom: fontsize-4}}>
                    <div style={{padding: 5, backgroundColor: greyChapter, width: 270, borderTopLeftRadius: 3, borderBottomLeftRadius: 3}}>
                        <p>Maître d'ouvrage</p>
                    </div>
                    <div style={{flex: 1, padding: 5, backgroundColor: greyclair, borderTopRightRadius: 3, borderBottomRightRadius: 3}}>
                        <p style={{overflow: 'hidden'}}>{props.projet[12] ? rescueHtml(props.projet[12]) : ""}</p>
                    </div>
                </div>
    
                {/* Partenaires à mobiliser */}
                <div style={{display: 'flex', marginBottom: fontsize-4}}>
                    <div style={{padding: 5, backgroundColor: greyChapter, width: 270, borderTopLeftRadius: 3, borderBottomLeftRadius: 3}}>
                        <p>Partenaires à mobiliser</p>
                    </div>
                    <div style={{flex: 1, padding: 5, backgroundColor: greyclair, borderTopRightRadius: 3, borderBottomRightRadius: 3}}>
                        <p style={{overflow: 'hidden'}}>{props.projet[13] ? rescueHtml(props.projet[13]) : ""}</p>
                    </div>
                </div>
            </div>
            
            {/* Footer */}
            <div style={{height: '20%', position: 'relative'}}>
                <div style={{position: 'absolute', bottom: 0}}>
                    <p style={{fontSize: (fontsize-2)}}>{props.date}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, left: '47%', display: 'flex'}}>
                    <p style={{fontSize: fontsize}}>page : {props.pagination} / {props.countPageTotal}</p>
                </div>
                <img style={{position: 'absolute', bottom: 0, right: 0, objectFit: 'contain', width: sizelogo, borderRadius: 5}} src={Logo} alt="Logo" />
            </div>

        </div>
    );
}
  
  export default Page2NomDonneesGenerales;